import { render } from "./AlertMessage.vue?vue&type=template&id=7097e93d"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/AlertMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7097e93d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7097e93d', __exports__)) {
    api.reload('7097e93d', __exports__)
  }
  
  module.hot.accept("./AlertMessage.vue?vue&type=template&id=7097e93d", () => {
    api.rerender('7097e93d', render)
  })

}


export default __exports__